import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import CONF from '../api/config';
import * as Cookie from '../lib/cookie';
import * as AuthState from '../state/reducer/auth/auth';
import * as NavState from '../state/reducer/nav/nav';

class PrivateRouteContainer extends Component {
    componentDidMount() {
        NavState.setPath(this.props.location, this.props.computedMatch);
        AuthState.checkToken();
    }

    componentDidUpdate(prevProps) {
        NavState.setPath(this.props.location, this.props.computedMatch);

        const {
            location: { pathname }
        } = this.props;
        const previousLocation = prevProps.location.pathname;

        if (pathname !== previousLocation) {
            window && window.Appcues && window.Appcues.page();
        }
    }

    render() {
        const { isAuthenticated, component: Component, ...props } = this.props;

        if (!isAuthenticated) {
            // isAuthenticated checks store, we also need to check cookie:
            let sessionToken = Cookie.getCookie(CONF.SESSION_NAME);
            AuthState.authWithCookie(sessionToken);
        }

        return <Route {...props} render={props => <Component {...props} />} />;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        isAuthenticated:
            state.auth.isAuthenticated && state.auth.loggedInUser !== false
    };
};

export default connect(mapStateToProps)(PrivateRouteContainer);



// WEBPACK FOOTER //
// ./src/lib/privateRoute.jsx